import React from 'react';
import _ from 'lodash';
import Button from '@material-ui/core/Button';
import TextField from 'components/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const StaplesOrderTypeModal = ({ state, setState, uploadPO }) => {
  const handleClose = () =>
    setState({
      ...state,
      staplesOrderTypeModal: false,
    });

  return (
    <Dialog
      fullWidth={true}
      maxWidth="lg"
      open={state?.staplesOrderTypeModal}
      onClose={handleClose}
    >
      <DialogTitle>Select Order Type</DialogTitle>

      <DialogContent>
        <TextField
          style={{ width: 200 }}
          type="date"
          label="Expected Shipped Date"
          defaultValue={null}
          value={state?.staplesShipDate}
          InputLabelProps={{
            shrink: true,
          }}
          onChange={(v) =>
            setState({
              ...state,
              staplesShipDate: v,
            })
          }
        />
      </DialogContent>
      <DialogActions>
        <Button
          disabled={!state?.staplesShipDate}
          onClick={() => {
            uploadPO();
          }}
          color="primary"
          variant="contained"
        >
          Upload PO
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StaplesOrderTypeModal;
